import { getEnumValues } from './get-enum-values';

export enum SoccerGameTiming {
	FullTime = 'Full Time',
	Overtime = 'Overtime',
}

export const SoccerGameTimingValues = getEnumValues <SoccerGameTiming>(SoccerGameTiming)
